module.exports = __webpack_public_path__ + "res/Roboto-Medium-webfontd41d.eot?a47037be2fd985780095442e4ea9d4e3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Medium-webfontd41d.eot
// module id = 77
// module chunks = 0